

import { useAPIClient } from '@src/api';
import { useBaseMutation } from '@src/corelib/query';


function useMutation(params) {
  const apiClient = useAPIClient();
  return useBaseMutation(apiClient, params);
}

export default useMutation;
